<script>
import app from '@/layouts/App.vue'

export default {
  name: 'TwNumber',
  props: {
    modelValue: {
      type: [String,Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    smallLabel: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    },
    required: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String,
      default: null
    },
    append: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue', 'update'],
  computed: {
    app () {
      return app
    },
    textSize() {
      return [
        {'text-sm': !this.size},
        {'text-2xl': this.size === 'lg'},
        {'text-sm': this.size === 'sm'},
      ]
    },
    inputClasses() {
      return [
        'block w-full rounded-md border-0 text-gray-900 ring-1 ring-inset ring-gray-300 hover:ring-gray-400 placeholder:text-gray-400 focus:ring-1 focus:ring-inset text-sm focus:ring-gray-800',
        '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
        {'py-2 min-h-[44px]': !this.size},
        {'py-3 text-xl': this.size === 'lg'},
        {'pl-10' : this.prepend !== null && this.size === 'lg'},
        {'pl-7' : this.prepend !== null && !this.size},
        { 'pr-8': this.append && this.size === 'lg'},
        { 'pr-6': this.append && !this.size},
        { 'pr-1': !this.append},
        {'': this.size === 'sm'}, //
      ]
    },
    appendClasses() {
      return [
        'h-full rounded-md border-0 bg-transparent py-1.5 pl-2 pr-2 text-gray-500 focus:ring-1 focus:ring-inset focus:ring-gray-800',
        {'text-sm': !this.size},
        {'text-3xl': this.size === 'lg'},
        {'text-sm': this.size === 'sm'},
      ]
    },

  }
}
</script>

<template>
  <div class="w-full">
    <label v-if="label" :for="id" class="block text-sm leading-6 text-gray-900 font-medium mb-2">{{ label }}</label>
    <div class="relative rounded-md shadow-sm">
      <div v-if="prepend" class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2">
        <span :class="['text-gray-500', ...textSize]">{{ prepend }}</span>
      </div>
      <input :id="id" :required="required" :value="modelValue" type="number" :name="id" :autocomplete="id" :class="inputClasses" :placeholder="placeholder" @input="$emit('update:modelValue', $event.target.value*1)">
      <div v-if="append" class="absolute inset-y-0 right-0 flex items-center">
        <label for="append" class="sr-only">{{ append }}</label>
        <span id="append" :class="appendClasses">
          {{ append }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
